import type { JSX } from "react";
import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import { SignUpStep } from "../step";


export class AlreadySubscribedStep extends SignUpStep {
	override title: string = "Check Your Subscription";
	override view: () => JSX.Element = () => <AlreadySubscribedStepView/>;
}

const AlreadySubscribedStepView = () => {
	return (
		<>
			<Alert severity="info">
				<AlertTitle>
					It looks like you already have a Charter Index subscription.
				</AlertTitle>
				<Stack gap={ 1 }>
					<Typography component="p">
						Please <a href="https://sign-in.charterindex.com">log in</a>,
						or <a href="https://sign-in.charterindex.com/reset">reset your password</a>.
					</Typography>
					<Typography component="p">
						If you are having problems gaining access to Charter Index,
						please <a href="https://agent.charterindex.com/contact-us">contact us</a> for
						support.
					</Typography>
				</Stack>
			</Alert>
		</>
	);
};
